// src/components/ui/TeamMembers.tsx

import { TeamMember } from '../../lib/types';
import Image from 'next/image';

interface TeamMembersProps {
  teamMembers: TeamMember[];
}

export function TeamMembers({ teamMembers }: TeamMembersProps) {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      {teamMembers.map((member: TeamMember, index: number) => (
        <div key={index} className="text-center">  
          {member.profilePicture ? (
            <div className="w-32 h-32 relative mx-auto mb-4">
              <Image src={member.profilePicture} alt={member.fullName} fill sizes="128px" className="object-cover rounded-full" />
            </div>
          ) : (
            <div className="w-32 h-32 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl text-gray-400">{member.fullName?.charAt(0)}</span>
            </div>
          )}
          <h3 className="text-xl font-semibold mb-1">{member.fullName}</h3>
          <p className="text-blue-600 font-medium mb-3">{member.role}</p>
        </div>
      ))}
    </div>
  );
}